export const chainTileState = {
  computed: {
    currentIndex() {
      const idx = this.sortedPackages.findIndex((p) => this.isCurrent(p));
      return idx >= 0 ? idx : 0;
    },
  },
  methods: {
    // Normalize backend `state` into: locked | current | collected.
    packageState(payPackage) {
      const state = (payPackage?.state || "").toLowerCase();
      if (state === "locked") return "locked";
      if (state === "current" || state === "unlocked" || state === "open")
        return "current";
      // purchased / collected / bought / done → collected
      return "collected";
    },
    isCurrent(payPackage) {
      return this.packageState(payPackage) === "current";
    },
    buttonLabel(payPackage) {
      if (this.packageState(payPackage) === "collected") {
        return this.$t("events.winter.collect_button");
      }
      return this.priceLabel(payPackage);
    },
    priceLabel(payPackage) {
      return this.isFreePackage(payPackage)
        ? this.freePriceLabel()
        : this.formatPrice(payPackage);
    },
    packageDisplayConfig(payPackage) {
      if (!payPackage?.display_config) return null;
      try {
        return typeof payPackage.display_config === "string"
          ? JSON.parse(payPackage.display_config)
          : payPackage.display_config;
      } catch (e) {
        console.error("Error parsing chain package display_config:", e);
        return null;
      }
    },
  },
};
